import { types } from 'mobx-state-tree';

export const OwnAssistanceItemModel = types.model('OwnAssistanceItemModel', {
  _id: types.identifier,
  type: types.string,
  title: types.maybeNull(types.string),
  description: types.maybeNull(types.string),
  linkInfo: types.maybeNull(types.string),
  image: types.maybeNull(types.string),
});

